import type { JobListItemViewProps } from '../JobListItemView.tsx';
import { useCallback } from 'react';
import isNewTabEvent from 'src/modules/is-new-tab-event';
import { useIsSplitViewEnabled } from 'src/store/featureFlags/hooks.ts';

export function useJobLinkOnClickCallback({
  jobDetailPageLink: { onBeforeNavigation },
  onClick,
}: Pick<JobListItemViewProps, 'onClick' | 'jobDetailPageLink'>) {
  const isSplitViewEnabled = useIsSplitViewEnabled();
  return useCallback(
    (e) => {
      if (isSplitViewEnabled) {
        if (!isNewTabEvent(e)) {
          onClick?.(e);
        } else {
          onBeforeNavigation?.();
        }
      }
    },
    [onBeforeNavigation, onClick, isSplitViewEnabled],
  );
}
